import { baseUrl, fetchWithAuth } from "./index";

export async function listUsers(page, limit) {
  return fetchWithAuth(`${baseUrl}/users/?page=${page}&limit=${limit}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export async function registerUser(userData) {
  return fetchWithAuth(`${baseUrl}/users/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });
}

export async function deleteUser(userId) {
  return fetchWithAuth(`${baseUrl}/users/${userId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export async function updateUser(userId, updatedData) {
  return fetchWithAuth(`${baseUrl}/users/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updatedData),
  });
}

export async function sendResetPasswordEmail(email) {
  return fetchWithAuth(
    `${baseUrl}/auth/forgot`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    },
    false,
  );
}

export async function getUserById(userId) {
  return fetchWithAuth(`${baseUrl}/users/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
}
